import {i18n} from '@/plugins/i18n'

export const bankId = {
    markazi: '010',
    sanatMadan: '011',
    mellat: '012',
    refah: '013',
    maskan: '014',
    sepah: '015',
    keshavarzi: '016',
    melli: '017',
    tejarat: '018',
    saderat: '019',
    toseeSaderat: '020',
    postBank: '021',
    toseeTaavon: '022',
    tosee: '051',
    ghavamin: '052',
    karafarin: '053',
    parsian: '054',
    eghtesadNovin: '055',
    saman: '056',
    pasargad: '057',
    sarmaye: '058',
    sina: '059',
    mehrIran: '060',
    shahr: '061',
    ayande: '062',
    ansar: '063',
    gardeshgari: '064',
    hekmatIranian: '065',
    day: '066',
    iranZamin: '069',
    resalat: '070',
    mehrIran2: '090',
    iranVenezuela: '095',
    noor: '080',
    kosar: '073',
    melal: '075',
    khavarmiane: '078',
    mehrEghtesad: '079',

    get(id) {
        let bankName = '-';

        Object.keys(bankId).forEach(item => {
            if (bankId[item] === id) {
                bankName = item
            }
        });

        return bankName;
    },

    mostUsedIds() {
        return [
            bankId.keshavarzi,
            bankId.saderat,
            bankId.ayande,
            bankId.saman,
            bankId.sina,
            bankId.parsian,
            bankId.pasargad,
            bankId.tejarat,
            bankId.melli,
            bankId.mellat,
        ];
    }
};

export const bankIdStr = {
    markazi: i18n.t('wallets.bank.markazi'),
    sanatMadan: i18n.t('wallets.bank.sanatMadan'),
    mellat: i18n.t('wallets.bank.mellat'),
    refah: i18n.t('wallets.bank.refah'),
    maskan: i18n.t('wallets.bank.maskan'),
    sepah: i18n.t('wallets.bank.sepah'),
    keshavarzi: i18n.t('wallets.bank.keshavarzi'),
    melli: i18n.t('wallets.bank.melli'),
    tejarat: i18n.t('wallets.bank.tejarat'),
    saderat: i18n.t('wallets.bank.saderat'),
    toseeSaderat: i18n.t('wallets.bank.toseeSaderat'),
    postBank: i18n.t('wallets.bank.postBank'),
    toseeTaavon: i18n.t('wallets.bank.toseeTaavon'),
    tosee: i18n.t('wallets.bank.tosee'),
    ghavamin: i18n.t('wallets.bank.ghavamin'),
    karafarin: i18n.t('wallets.bank.karafarin'),
    parsian: i18n.t('wallets.bank.parsian'),
    eghtesadNovin: i18n.t('wallets.bank.eghtesadNovin'),
    saman: i18n.t('wallets.bank.saman'),
    pasargad: i18n.t('wallets.bank.pasargad'),
    sarmaye: i18n.t('wallets.bank.sarmaye'),
    sina: i18n.t('wallets.bank.sina'),
    mehrIran: i18n.t('wallets.bank.mehrIran'),
    shahr: i18n.t('wallets.bank.shahr'),
    ayande: i18n.t('wallets.bank.ayande'),
    ansar: i18n.t('wallets.bank.ansar'),
    gardeshgari: i18n.t('wallets.bank.gardeshgari'),
    hekmatIranian: i18n.t('wallets.bank.hekmatIranian'),
    day: i18n.t('wallets.bank.day'),
    iranZamin: i18n.t('wallets.bank.iranZamin'),
    resalat: i18n.t('wallets.bank.resalat'),
    mehrIran2: i18n.t('wallets.bank.mehrIran2'),
    iranVenezuela: i18n.t('wallets.bank.iranVenezuela'),
    noor: i18n.t('wallets.bank.noor'),
    kosar: i18n.t('wallets.bank.kosar'),
    melal: i18n.t('wallets.bank.melal'),
    khavarmiane: i18n.t('wallets.bank.khavarmiane'),
    mehrEghtesad: i18n.t('wallets.bank.mehrEghtesad'),

    get(id) {
        let bankName = '-';

        Object.keys(bankId).forEach(item => {
            if (bankId[item] === id) {
                bankName = bankIdStr[item];
            }
        });

        return bankName;
    }
};
